import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductBadges extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateBadges);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateBadges);
  }

  /**
   * Updates the inventory.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateBadges = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newBadges = event.detail.data.html.querySelector(this.localName);

    if (!newBadges) return;

    // Update the class to add/remove --empty state
    this.className = newBadges.className;

    morph(this, newBadges, { childrenOnly: true });
  };
}

if (!customElements.get('product-badges')) {
  customElements.define('product-badges', ProductBadges);
}

class ProductBadgesMobile extends ProductBadges {}

if (!customElements.get('product-badges-mobile')) {
  customElements.define('product-badges-mobile', ProductBadgesMobile);
}

class ProductSaleBadges extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateSaleBadges);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateSaleBadges);
  }

  /**
   * Updates the sale badges.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateSaleBadges = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newSaleBadges = event.detail.data.html.querySelector(this.localName);

    if (!newSaleBadges) return;

    // Ensure --empty state is removed when new badges are available
    newSaleBadges.classList.remove('product-sale-badges--empty');
    this.className = newSaleBadges.className;

    morph(this, newSaleBadges, { childrenOnly: true });
  };
}

if (!customElements.get('product-sale-badges')) {
  customElements.define('product-sale-badges', ProductSaleBadges);
}

class ProductSaleBadgesMobile extends ProductSaleBadges {}

if (!customElements.get('product-sale-badges-mobile')) {
  customElements.define('product-sale-badges-mobile', ProductSaleBadgesMobile);
}
